import { CREATE_ERROR, CLEAR_ERROR } from '../types/errorTypes';

export const clearErrorAction = () => ({
  type: CLEAR_ERROR,
});

export const addErrorAction = (error) => ({
  type: CREATE_ERROR,
  payload: error,
});
